import { createContext } from "react";

const SessionPresentationContext = createContext({
  isPresenting: false,
  sessionTitle: "",
  setSessionPresentation: () => {},
});

export default SessionPresentationContext;
